import { withTranslation } from "react-i18next";

import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Header } from '../Common';
import Notifications from '../../Models/Notifications';
import { BuyerSidebar } from '../Common/BuyerSidebar';
import { SideBar } from '../Common/SideBar';
import { AffiliatorSidebar } from '../Common/AffiliatorSidebar';
import { Badge } from 'reactstrap';
var striptags = require('striptags');

class AllNotification extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            _id: false,
            allNotifications: [],
            count: '',
        }
        this.getNotification()
    }

    getNotification() {
        if (localStorage.getItem('info') !== null) {
            var x = JSON.parse(localStorage.getItem('info'))
            Notifications.getAll(x.id).then(res => {
                if (res.data.payload !== null) {
                    this.setState({ allNotifications: res.data.payload, count: res.data.count })
                }
            })
        }
    }

    openStatus(id) {
        console.log(id)
        if (localStorage.getItem('info') !== null) {
            var x = JSON.parse(localStorage.getItem('info'))
            Notifications.getStatus(id).then(res => {
                console.log(res.data)
                if (res.data.payload !== null) {
                    this.setState({ unreadStatus: res.data.payload })
                }
            })
        }
    }

    serviceTransaction(title) {
        if (localStorage.getItem('info') !== null) {
            var x = JSON.parse(localStorage.getItem('info'))
            if (x.user_type_id === 1) {
                return (
                    <Link to={{
                        pathname: `/buyer-transaction`
                    }} style={{ textDecoration: 'none', fontSize: '12px' }} className="category-right row">
                        <div className="col-md-12" >
                            {title}
                        </div>

                    </Link>
                )
            } else if (x.user_type_id === 2) {
                return (
                    <Link to={{
                        pathname: `/seller-transaction`
                    }} style={{ textDecoration: 'none', fontSize: '12px' }} className="category-right row">
                        <div className="col-md-12" >
                            {title}
                        </div>

                        {/* <div className="col-md-1" style={{ paddingLeft: '5px' }}>
                            <Badge color="danger">!</Badge>
                        </div> */}
                    </Link>
                )
            } else if (x.user_type_id === 3) {
                return (
                    <Link to={{
                        pathname: `/affiliator-buyer-transaction`
                    }} style={{ textDecoration: 'none', fontSize: '12px' }} className="category-right row">
                        <div className="col-md-12" >
                            {title}
                        </div>

                    </Link>
                )
            }
        }
    }

    serviceAccept(name, id, seller_id) {
        if (localStorage.getItem('info') !== null) {
            var x = JSON.parse(localStorage.getItem('info'))
            if (x.user_type_id === 1) {
                return (
                    <Link to={{
                        pathname: `/buyer-request-estimation-details`,
                        state: { id: id }
                    }} style={{ textDecoration: 'none', fontSize: '12px' }} className="category-right row">
                        <div className="col-md-12" >
                            {name}
                        </div>

                    </Link>
                )
            } else if (x.user_type_id === 2) {
                return (
                    <Link to={{
                        pathname: `/request-details/${id}`,
                        state: { id: id, user: seller_id }
                    }} style={{ textDecoration: 'none', fontSize: '12px' }} className="category-right row">
                        <div className="col-md-12" >
                            {name}
                        </div>

                    </Link>
                )
            } else if (x.user_type_id === 3) {
                return (
                    <Link to={{
                        pathname: `/buyer-request-estimation-details`,
                        state: { id: id }
                    }} style={{ textDecoration: 'none', fontSize: '12px' }} className="category-right row">
                        <div className="col-md-12" >
                            {name}
                        </div>

                    </Link>
                )
            }
        }
    }

    serviceServe(name) {
        if (localStorage.getItem('info') !== null) {
            var x = JSON.parse(localStorage.getItem('info'))
            if (x.user_type_id === 1) {
                return (
                    <Link to={{
                        pathname: `/buyer-transaction`
                    }} style={{ textDecoration: 'none', fontSize: '12px' }} className="category-right row">
                        <div className="col-md-12">
                            {name}
                        </div>

                    </Link>
                )
            } else if (x.user_type_id === 2) {
                return (
                    <Link to={{
                        pathname: `/seller-buyer-transaction`
                    }} style={{ textDecoration: 'none', fontSize: '12px' }} className="category-right row">
                        <div className="col-md-12">
                            {name}
                        </div>

                    </Link>

                )
            } else if (x.user_type_id === 3) {
                return (
                    <Link to={{
                        pathname: `/affiliator-buyer-transaction`
                    }} style={{ textDecoration: 'none', fontSize: '12px' }} className="category-right row">
                        <div className="col-md-12">
                            {name}
                        </div>

                    </Link>
                )
            }
        }
    }

    newResponse(name, res_id, pro_id) {
        if (localStorage.getItem('info') !== null) {
            var x = JSON.parse(localStorage.getItem('info'))
            if (x.user_type_id === 1) {
                if (pro_id > 0) {
                    return (
                        <Link to={{
                            pathname: `/buyer-request-estimation-details`,
                            state: { id: res_id }
                        }} className="row" style={{ textDecoration: 'none', fontSize: '12px' }} className="category-right">
                            <div className="col-md-12" >
                                {name}
                            </div>

                        </Link>

                    )
                } else {
                    return (
                        <Link to={{
                            pathname: `/buyer-request-details`,
                            state: { id: res_id }
                        }} className="row" style={{ textDecoration: 'none', fontSize: '12px' }} className="category-right">
                            <div className="col-md-12" >
                                {name}
                            </div>

                        </Link>
                    )
                }
            } else if (x.user_type_id === 2) {
                if (pro_id > 0) {
                    return (
                        <Link to={{
                            pathname: `/buyer-request-estimation-details`,
                            state: { id: res_id }
                        }} className="row" style={{ textDecoration: 'none', fontSize: '12px' }} className="category-right">
                            <div className="col-md-12" >
                                {name}
                            </div>

                        </Link>

                    )
                } else {
                    return (
                        <Link to={{
                            pathname: `/seller-buyer-request-details`,
                            state: { id: res_id }
                        }} className="row" style={{ textDecoration: 'none', fontSize: '12px' }} className="category-right">
                            <div className="col-md-12" >
                                {name}
                            </div>

                        </Link>

                    )
                }
            } else if (x.user_type_id === 3) {
                if (pro_id > 0) {
                    return (
                        <Link to={{
                            pathname: `/buyer-request-estimation-details`,
                            state: { id: res_id }
                        }} className="row" style={{ textDecoration: 'none', fontSize: '12px' }} className="category-right">
                            <div className="col-md-12" >
                                {name}
                            </div>

                        </Link>

                    )
                } else {
                    return (
                        <Link to={{
                            pathname: `/affiliator-request-details`,
                            state: { id: res_id }
                        }} className="row" style={{ textDecoration: 'none', fontSize: '12px' }} className="category-right">
                            <div className="col-md-12" >
                                {name}
                            </div>

                        </Link>
                    )
                }
            }
        }
    }

    notificationType(type, name, pro_id, id, res_id, seller_id) {
        const renderHTML = (rawHTML) => React.createElement("div", { dangerouslySetInnerHTML: { __html: rawHTML } });
        if (type === 'PURCHASE') {
            return (
                <div className="">
                    {this.serviceTransaction(name)}
                </div>
            )
        } else if (type === 'SYSTEM') {
            return (
                <div className="row" >
                    <Link to={{
                        pathname: '/system-notification',
                        state: { id: id }
                    }} style={{ textDecoration: 'none', fontSize: '12px' }} className="category-right col-md-11">{striptags(name.substr(0, 100))}</Link>

                </div>
            )
        } else if (type === 'REQUESTDECLINED') {
            return (
                <div className="" ></div>
            )
        } else if (type === 'SERVICERECEIVED') {
            return (
                <div className="row">
                    <Link to={{
                        pathname: '/seller-complete-cancel',
                        state: { id: id, type: type }
                        // state:{id:}
                    }} style={{ textDecoration: 'none', fontSize: '12px' }} className="category-right col-md-11">{name}</Link>

                </div>
            )
        } else if (type === 'SERVED') {
            return (
                <div >
                    {this.serviceServe(name)}
                </div>
            )
        } else if (type === 'RESPONSEACCEPTED') {
            return (
                <div >
                    {this.serviceAccept(name, res_id, seller_id)}
                </div>
            )
        } else if (type === 'REQUESTRECEIVED') {
            return (
                <div className="row"  >
                    <Link to={{
                        pathname: `/request-details/${res_id}`,
                        state: { id: res_id, type: type }
                        // state:{id:}
                    }} style={{ textDecoration: 'none', fontSize: '12px' }} className="category-right col-md-11">{name}</Link>

                </div>
            )
        } else if (type === 'RECRUITMENTCLOSED') {
            return (
                <div className="row" >
                    <Link to={{
                        pathname: '/request-notification-close',
                        state: { id: id, type: type }
                        // state:{id:}
                    }} style={{ textDecoration: 'none', fontSize: '12px' }} className="category-right col-md-11">{name}</Link>

                </div>
            )
        } else if (type === 'FOLLOW') {
            return (
                <div className="row" >
                    <Link to={{
                        pathname: '/followers',
                        state: { id: id, type: type }
                        // state:{id:}
                    }} style={{ textDecoration: 'none', fontSize: '12px' }} className="category-right col-md-11">{name}</Link>

                </div>
            )
        } else if (type === 'NEWRESPONSE') {
            return (
                <div className="" >
                    {this.newResponse(name, res_id, pro_id)}
                </div>
            )
        } else if (type === 'REVIEW') {
            return (
                <div className="row" >
                    <Link to={{
                        pathname: `/categories-details/${pro_id}`,
                        state: { id: pro_id }
                        // state:{id:}
                    }} style={{ textDecoration: 'none', fontSize: '12px' }} className="category-right col-md-11">
                        {name}
                    </Link>

                </div>
            )
        } else if (type === 'COMMISSIONRECEIVED') {
            return (
                <div className="row" >
                    <Link to={{
                        pathname: `/affiliator-sales-management`,
                        // state: { id: pro_id }
                        // state:{id:}
                    }} style={{ textDecoration: 'none', fontSize: '12px' }} className="category-right col-md-11">
                        {name}
                    </Link>

                </div>
            )
        }
    }

    showSidebar() {
        if (localStorage.getItem('info') !== null) {
            var x = JSON.parse(localStorage.getItem('info'))
            if (x.user_type_id === 1) {
                return (
                    <BuyerSidebar />
                )
            } else if (x.user_type_id === 2) {
                return (
                    <SideBar />
                )
            } else if (x.user_type_id === 3) {
                return (
                    <AffiliatorSidebar />
                )
            }
        }
    }

    notificationBadge(status) {
        console.log(this.state.count)
        if (status == "OPENED") {
            return (
                <div className=""></div>
            )
        } else {
            return (
                <Badge className="" style={{ padding: '0px', color: '#dc3545', backgroundColor: '#fff', fontSize: '18px', marginTop: '4px' }}><i class="fas fa-exclamation-circle"></i></Badge>
            )
        }
    }
    render() {
        console.log("!!!!!!!!! ", this.state.allNotifications);
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        //For Mobile view
        if (isMobile) {
            return (
                <div className="">
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5 "></div>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-8">
                                <div className="">
                                    {this.props.t('0')}
                                </div>
                                <div className="" style={{ border: '1px solid #ccc', padding: '15px 0px', maxHeight: '600px', overflowY: 'auto' }}>
                                    {this.state.allNotifications.map(res =>
                                        <div className="col-md-12">
                                            <div className="row" >
                                                <div className="col-2" style={{ padding: '0px 10px', textAlign: 'center' }}>
                                                    {this.notificationBadge(res.opening_status)}
                                                </div>
                                                <div className="col-10" style={{ paddingLeft: '0px' }} onClick={this.openStatus.bind(this, res.id)}>
                                                    {this.notificationType(res.notification_type, res.notification_text, res.product_id, res.id, res.request_id, res.seller_id, res.opening_status)}
                                                </div>
                                            </div>
                                            <hr />
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )
        }
        //for desktop view
        else if (isDesktop) {
            return (
                <div className="">
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5 "></div>
                    <div className="container-fluid">
                        <div className="container">
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-4 input_name">
                                        {this.showSidebar()}
                                    </div>
                                    <div className="col-md-8">
                                        <div className="">
                                            {this.props.t('0')}
                                        </div>
                                        <div className="" style={{ border: '1px solid #ccc', padding: '15px', maxHeight: '700px', overflowY: 'auto' }}>
                                            {this.state.allNotifications.map(res =>
                                                <div className="col-md-12">
                                                    <div className="row" >
                                                        <div className="col-md-11" onClick={this.openStatus.bind(this, res.id)}>
                                                            {this.notificationType(res.notification_type, res.notification_text, res.product_id, res.id, res.request_id, res.seller_id, res.opening_status)}
                                                        </div>
                                                        <div className="col-md-1">
                                                            {this.notificationBadge(res.opening_status)}
                                                        </div>
                                                    </div>
                                                    <hr />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )
        }
    }
}
export { AllNotification }

 AllNotification = withTranslation('src_Components_Notification_AllNotification')(AllNotification);
